import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDtTrigger.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return /^(BDLOGIC)$/.test(type)
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'BDLOGIC'},
            ]
        },
    })
}
